import actions from "./actions.js";
import getters from "./getters.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {
            feedList: [],
            totalFeedCount: 0,
            feedTypeList: [],
            answerTypeList: []
        }
    },
    getters,
    actions,
    mutations
}